(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1100px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.isOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liplay-points"] && !Shopify.designMode) return;
  try {
    
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
    }
  });
}, { threshold: 0.5 });

document.querySelectorAll('.lip-points__1').forEach(el => observer.observe(el));

document.querySelectorAll('.tab-content_wrap p').forEach((tab, index) => {
  tab.addEventListener('click', function () {
    const wrap = this.closest('.lip-points__2_img-tab');

    // toggle active tab
    wrap.querySelectorAll('.tab-content_wrap p').forEach(t => t.classList.remove('tab-active'));
    this.classList.add('tab-active');

    // toggle active image
    wrap.querySelectorAll('.tab-img_wrap img').forEach((img, i) => {
      img.classList.toggle('tab-img-active', i === index);
    });
  });
});

// set initial active image on load
document.querySelectorAll('.lip-points__2_img-tab').forEach(wrap => {
  const activeIndex = [...wrap.querySelectorAll('.tab-content_wrap p')]
    .findIndex(p => p.classList.contains('tab-active'));
  wrap.querySelectorAll('.tab-img_wrap img').forEach((img, i) => {
    img.classList.toggle('tab-img-active', i === activeIndex);
  });
});
const cardLower = document.querySelector('.lip-points__card.card_lower');

const filmObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const wrap = entry.target;
    const films = [
      wrap.querySelector('.films_1'),
      wrap.querySelector('.films_2'),
      wrap.querySelector('.films_3'),
      wrap.querySelector('.films_4'),
    ];
    const cFilm = wrap.querySelector('.c_film');

    films.forEach(film => {
      if (film) film.classList.add('film-visible');
    });

    setTimeout(() => {
      if (cFilm) cFilm.classList.add('film-visible');
    }, 900); // 800ms animation + 100ms buffer

    filmObserver.unobserve(wrap);
  });
}, { threshold: 0.6 });

if (cardLower) filmObserver.observe(cardLower);

document.addEventListener('DOMContentLoaded', () => {

  // ── card 1: cimg zoom ──
  const card1 = document.querySelector('.lip-points__3 .lip-points__card');
  if (card1) {
    const obs1 = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            entry.target.classList.add('is-visible');
          });
        });
        obs1.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    obs1.observe(card1);
  }

  // ── card-2 instances: cimg1 + cimg2 slide ──
  const cards2 = document.querySelectorAll('.lip-points__card-2');
  if (cards2.length) {
    const obs2 = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            entry.target.classList.add('is-visible');
          });
        });
        obs2.unobserve(entry.target);
      });
    }, { threshold: 0.6 });

    cards2.forEach(card => obs2.observe(card));
  }

});

  } catch(e) { console.error(e); }
})();
})();
